import { app } from '../../../bootstrap/core';
import {NotificationService} from './notification.service';

app.service('notificationService', NotificationService);